/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { showSuccess } from "~/components/Toast";
import {
  generateActionSuccessText,
  itHasNotOnlyWhitespace,
  useAxios,
} from "~/tools";
import { maxLength } from "~/tools/validation/validators";
import { ServiceViewCtx } from "./ServiceViewCtx";

export default function () {
  const { service, refetch } = React.useContext(ServiceViewCtx);

  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const methods = useForm();

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const onSubmit = async (values: { name: string }) => {
    setLoading(true);
    try {
      const data = { ...values, serviceId: service.id };
      await Axios().post("/request-categories", data);
      showSuccess(
        generateActionSuccessText(`Request category ${values.name}`)()(
          "added"
        )()
      );
      setLoading(false);
      setIsSidebarOpen(false);

      return refetch();
    } catch (e) {
      showError(e.response);
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        size="sm"
        icon="plus"
        severity="low"
        onClick={() => setIsSidebarOpen(true)}
      >
        Add category
      </Button>

      <SidebarForm
        title="Add new request category"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField
          name="name"
          label="Name"
          required
          registerOptions={{
            ...maxLength(100),
            validate: itHasNotOnlyWhitespace,
          }}
        />

        <SidebarFormButtons
          submitText="Add"
          submitEnabled={!!methods.watch("name")}
          submitLoading={loading}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}
